import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationReadyBox } from "web_myplann/Inspiration/Components/InspirationReadyBox";
import { EARLY_FREEDOM_READY_STEPS } from "web_myplann/Inspiration/EarlyFreedom/constants";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	context: EarlyFreedomContext;
	onContact: () => void;
};

export const EarlyFreedomReadyBox: FC<Props> = ({ context, onContact }) => {
	const { t } = useResource();
	const isFull = context.coverageRatio >= 100;

	return (
		<InspirationReadyBox
			kicker={t(R.readyKicker)}
			title={isFull ? t(R.readyTitleFull) : t(R.readyTitleAlmost)}
			description={isFull ? t(R.readyDescFull) : t(R.readyDescAlmost)}
			steps={EARLY_FREEDOM_READY_STEPS.map((step) => ({
				icon: step.icon,
				title: t(step.title),
				subtitle: t(step.subtitle),
			}))}
			contactLabel={t(R.contactAdvisor)}
			onContact={onContact}
		/>
	);
};
